<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        Reward Activities
      </h1>

      <div
        v-if="offers.areLoading"
        class="cf-section-loader-container"
      >
        <div class="cf-loader" />
      </div>

      <template v-else-if="offers.loyaltyTransactions.activities && offers.loyaltyTransactions.activities.length === 0">
        <h4 class="cf-title cf-title--4">
          Looks like you don't have any rewards yet.
        </h4>

        <p class="cf-subtitle cf-subtitle--2">
          After you checkout, you can view your rewards here.
        </p>
      </template>

      <template v-else>
        <div
          v-for="(activity, activityIdx) in offers.loyaltyTransactions.activities"
          :key="activityIdx"
          class="cf-card cf-flex cf-flex--column cf-flex--gap-12 cf-height-150"
        >
          <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between">
            <h4 class="cf-title cf-title--4">
              {{ activity.title }}
            </h4>
          </div>

          <div class="cf-grid cf-grid--2-grid-column-equal">
            <!-- left grid column -->
            <div class="cf-flex cf-flex--column cf-flex--gap-12">
              <p
                v-for="(details, idx) in activity.leftDetails"
                :key="idx"
                :class="['cf-subtitle cf-subtitle--2', { 'cf-subtitle--brand-primary cf-subtitle--heavy ': details.appearance === 'Special2' }]"
              >
                {{ details.content }}
              </p>
            </div>

            <!-- right grid column -->
            <div class="cf-flex cf-flex--column cf-flex--align-end cf-flex--gap-12">
              <p
                v-if="activity.primaryAchievement"
                :class="['cf-subtitle cf-subtitle--2', { 'cf-subtitle--green cf-subtitle--heavy': activity.primaryAchievement['appearance'] === 'Special1' }]"
              >
                {{ activity.primaryAchievement["content"] }}
              </p>
              <p
                v-for="(details, idx) in activity.rightDetails"
                :key="idx"
                :class="['cf-subtitle cf-subtitle--2', { 'cf-subtitle--brand-primary': details.appearance === 'Special2' }]"
              >
                {{ details.content }}
              </p>
            </div>
          </div>
        </div>
      </template>

      <div
        v-if="offers.loyaltyTransactions.hasMore"
        class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-padding-y-16"
      >
        <div
          v-show="offers.moreOffersLoading"
          class="cf-loader"
        />
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'LoyaltyActivityPage',

    metaInfo() {
      return {
        title: 'Rewards Activities'
      };
    },

    data() {
      return {
        requestDataOffset: 0
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['offers', 'loyalty'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        if (this.merchant.features['loyalty-activity-tab-enabled'] && this.loyalty.isEnrolled) {
          await this.getLoyaltyTransactions();

          this.handleGetScrolledActivities();
        }
        else {
          this.$router.replace({ name: 'orderMenu' });
        }
      },

      handleGetScrolledActivities() {
        window.addEventListener('scroll', async () => {
          if (Math.ceil(window.scrollY) + window.innerHeight + 10 >= document.body.scrollHeight && this.offers.loyaltyTransactions.hasMore) {
            /** Need to scroll up just above scrollY height,
             * then make request as to not let mutlitple requests kick off while at bottom of screen.
            */
            window.scrollBy({ top: -100, behavior: 'smooth' });

            /** Let scroll event finish then make request - bit of a hack */
            await this.$nextTick();

            await this.getLoyaltyTransactions();
          }
        });
      },

      async getLoyaltyTransactions() {
        await this.$store.dispatch('offers/getLoyaltyTransactions', this.requestDataOffset);

        this.requestDataOffset += 25;
      }
    }
  };
</script>
